import React, { useEffect, useState, useContext } from 'react';
import union from '@turf/union';
// import Warning from './Warning';
import { FarmContext, GEO_URL } from './FarmContext';
import { AppContext } from './AppContext';


const useDates = () => {
  const year = new Date().getFullYear() - 1;

  const [mapLayer, setMapLayer] = React.useState([]);
  const [start, setStart] = useState(`${year}-01-01`);
  const [end, setEnd] = useState(`${year}-12-31`);
  
  const { boundary } = useContext(FarmContext);
  const { mapboxRef, showing } = useContext(AppContext);

  // TODO fix redo/undo
  useEffect(() => {
      if (boundary.features.length === 0) return;
      if (!showing['WIP Flood']) return;
      console.log('fetching flood')
      const combined = boundary.features.reduce((acc, cur) => {
        return union(acc, cur);
      });
      fetch(GEO_URL + '/geoserver/flood', {
        method: 'POST',
        body: JSON.stringify({
            boundary: combined,
            start: start,
            end: end,
        }),
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
        .then(r => r.json())
        .then(r => {
          setMapLayer([{...r, id: 'flood'}]);
        })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boundary, start, end]);

  useEffect(() => {
    // TODO true?
    const toggle = true;
    console.log('1');
    updateLayer(mapboxRef, mapLayer, toggle);
  }, [mapLayer, mapboxRef]);

  return { start, setStart, end, setEnd, mapLayer };
}

// TODO merge with NDVI
export const FloodDateControl = () => {
    const { start, setStart, end, setEnd } = useDates();
    return <div>
      <input id="start" type="date" value={start} onChange={evt => setStart(evt.target.value)}/>
      <span> to </span>
      <input id="end" type="date" value={end} onChange={evt => setEnd(evt.target.value)}/>
    </div>
}


const updateLayer = (mapboxRef, mapLayer, toggle) => {
  if (!mapboxRef.current) return;

  if (toggle) {
    mapLayer.forEach(l => {
      if (mapboxRef.current.getLayer(l.id)) mapboxRef.current.removeLayer(l.id);
      if (mapboxRef.current.getSource(l.id)) mapboxRef.current.removeSource(l.id);
      mapboxRef.current.addLayer(l);
    });
   
  } else {
    // TODO hack because useNdviToggle below doesn't keep mapLyaer fresh
    const id = 'flood';
    if (mapboxRef.current.getLayer(id)) mapboxRef.current.removeLayer(id);
    if (mapboxRef.current.getSource(id)) mapboxRef.current.removeSource(id);
  }

}


export const useFloodToggle = () => {
  const { mapboxRef } = useContext(AppContext);
  const { mapLayer } = useDates();

  const ndviToggle = (toggle) => {
    updateLayer(mapboxRef, mapLayer, toggle);
  };

  return ndviToggle;
}


export default Map;

